module.exports = {"654022100":"察布查尔镇","654022101":"爱新色里镇","654022102":"孙扎齐牛录镇","654022103":"绰霍尔镇","654022104":"加尕斯台镇","654022105":"琼博拉镇","654022106":"海努克镇","654022200":"堆齐牛录乡","654022203":"纳达齐牛录乡","654022204":"扎库齐牛录乡","654022205":"米粮泉回族乡","654022206":"坎乡","654022207":"阔洪奇乡","654022401":"安班巴格良繁场","654022403":"伊犁州平原林场","654022404":"山区林场","654022408":"都拉塔口岸","654022503":"兵团六十七团分部","654022504":"兵团六十九团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654022.json
// module id = 3271
// module chunks = 0